import { AnimatePresence } from 'framer-motion';
import React, { FunctionComponent, useEffect } from 'react';

import ErrorScreen from 'components/ErrorScreen/ErrorScreen';

import * as Styled from './WindowTooSmall.styles';

export interface WindowTooSmallProps {
  isVisible?: boolean;
}

const defaultProps: Partial<WindowTooSmallProps> = {
  isVisible: false,
};

const WindowTooSmall: FunctionComponent<WindowTooSmallProps> = ({
  isVisible,
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <Styled.Wrapper>
          <ErrorScreen errorType="windowTooSmall" />
        </Styled.Wrapper>
      )}
    </AnimatePresence>
  );
};

WindowTooSmall.defaultProps = defaultProps;

export default WindowTooSmall;
